
<script setup>

  import { ref, watch, onMounted } from 'vue';

  import { ArrowRightCircleIcon } from '@heroicons/vue/24/outline';

  import { seenPlayerDialog } from '../stores/activity-5.js';

  import backgroundPath from '../images/wood-background.jpg';

  const ready = ref( false );

  onMounted( () => {

    watch( seenPlayerDialog, () => {

      if ( seenPlayerDialog.value ) setTimeout( () => ready.value = true, 100 );

    }, { immediate: true } );

  } );

</script>

<template>

  <article>

    <div class="grid items-center justify-center min-h-view bg-fixed bg-cover bg-center"
    
      :style="{ backgroundImage: `url( ${ backgroundPath } )` }">

      <div class="p-6 md:p-12 lg:p-24">

        <div class="max-w-xl">

          <h2 class="pb-6 border-b-[3px] border-black">

            <div class="text-xl tracking-narrow font-semibold uppercase">Activity 5</div>

            <div class="text-4xl md:text-5xl font-heading uppercase">Telling the Whole Story</div>

          </h2>

          <p class="mt-8 leading-7 text-neutral-700">

            The mission of the National Park Service is to
            
            "preserve unimpaired the natural and cultural resources
            
            and values of the National Park System for the enjoyment,
            
            education, and inspiration of this and future generations."

          </p>

          <p class="mt-8 leading-7 text-neutral-700">

            Part of that responsibility is to preserve and tell the stories
            
            that make up our shared history. Think about what our responsibility
            
            is in telling the stories of Lewis Mountain in ways that educate and inspire.

          </p>

          <h3 class="mt-8 text-2xl md:text-3xl font-medium font-serif italic">About This Activity</h3>

          <p class="mt-4 leading-7 text-neutral-700">

            Interpretation within the National Park Service aims to help visitors make
            
            their own connections to the park and its past &mdash; to imagine themselves

            in park stories and make intellectual and emotional connections.

          </p>

          <p class="mt-8 leading-7 text-neutral-700">

            Choose one of the topics covered in the previous activities and

            develop an educational sign that could be displayed at Lewis Mountain

            in Shenandoah National Park.

          </p>

          <div class="flex gap-6 flex-wrap mt-12">

            <RouterLink
            
              class="inline-flex items-center gap-4 px-6 py-4 text-white font-bold bg-green-700 transition-colors
              
                hover:bg-green-800 focus-visible:bg-green-800 hover:underline focus-visible:underline"
            
              to="/activity/5/step/1">

              <span>Continue</span>

              <ArrowRightCircleIcon class="w-8" />

            </RouterLink>

          </div>

        </div>

      </div>

    </div>

  </article>

</template>
